import { Injectable, signal } from '@angular/core';

/**
 * Mensaje por defecto mostrado al usuario cuando la sesión expira.
 */
const DEFAULT_MESSAGE = 'Tu sesión ha expirado. Por favor, inicia sesión nuevamente.';

/**
 * Estado compartido para el diálogo de "sesión expirada".
 *
 * El interceptor invoca {@link show} cuando una petición devuelve el código 1003,
 * y el componente raíz reacciona a estos signals para mostrar el alert-dialog de
 * SpartanUI. Mantener el estado aquí permite abrir el diálogo de forma imperativa
 * desde el interceptor sin acoplarlo a ningún componente.
 */
@Injectable({
  providedIn: 'root',
})
export class SessionExpiredService {
  private readonly _isOpen = signal(false);
  private readonly _message = signal(DEFAULT_MESSAGE);

  /** Indica si el diálogo de sesión expirada debe mostrarse. */
  public readonly isOpen = this._isOpen.asReadonly();

  /** Mensaje a mostrar dentro del diálogo. */
  public readonly message = this._message.asReadonly();

  /**
   * Solicita mostrar el diálogo. Si ya está visible, ignora la llamada para evitar
   * que múltiples peticiones fallidas en paralelo reabran el mensaje.
   */
  show(message?: string): void {
    if (this._isOpen()) {
      return;
    }
    this._message.set(message?.trim() ? message : DEFAULT_MESSAGE);
    this._isOpen.set(true);
  }

  /** Oculta el diálogo. */
  dismiss(): void {
    this._isOpen.set(false);
  }
}
